goog.provide("shadow.js.shim.module$$mui$material$Modal");
goog.provide("module$shadow_js_shim_module$$mui$material$Modal");
shadow.js.shim.module$$mui$material$Modal = shadow.js.nativeProvides["@mui/material/Modal"] = shadow$bridge("@mui/material/Modal");
module$shadow_js_shim_module$$mui$material$Modal.default = shadow.js.shim.module$$mui$material$Modal;
